import ApiServer from '../constants/app/apiServer/constants'

let apiToken;
let currentLocale = "zh-tw";

class DomainCommon {
    static fetch({url, resolve, reject, method, jsonBody, optionHeaders = {}}) {

        // 當沒有 apiToken 且不是要 login , 就不 fetch
        // if (!apiToken && isLogin === false) return;

        let options = method ? {method} : {};
        options = jsonBody ?
            Object.assign(options, {body: JSON.stringify(jsonBody)}) :
            options;

        // set apiTokenHeader if available
        options.headers = Object.assign({
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'locale': currentLocale,
        }, getApiTokenHeader(), optionHeaders);

        return _fetch(url, options, resolve, reject);
    }

    static fetchGet({url, resolve, reject}) {
        return this.fetch({url, resolve, reject, method: 'GET'});
    }

    static fetchPost({url, jsonBody, resolve, reject}) {
        return this.fetch({url, resolve, reject, method: 'POST', jsonBody});
    }

    static fetchPut({url, jsonBody, resolve, reject}) {
        return this.fetch({url, resolve, reject, method: 'PUT', jsonBody});
    }

    static fetchPatch({url, jsonBody, resolve, reject}) {
        return this.fetch({url, resolve, reject, method: 'PATCH', jsonBody});
    }

    static fetchDelete({url, jsonBody, resolve, reject}) {
        return this.fetch({url, resolve, reject, method: 'DELETE', jsonBody});
    }

    static getUecareApiUrl() {
        return ApiServer.url;
    }

    static setApiToken(token) {
        apiToken = token;
    }

    static clearApiToken() {
        apiToken = '';
    }

    static getApiToken() {
        return apiToken;
    }

    static setLocale(locale) {
        currentLocale = locale;
    }

    static buildQueryString(params) {
        return Object.keys(params)
            .filter(key => params[key])
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
            .join('&')
    }
}

async function _fetch(url, options, resolve, reject) {
    try {
        let response = await fetch(url, options);

        if (check2XXStatus(response.status)) {
            if (response.status === 204) {
                resolve({});
            } else {
                try {
                    let responseJson = await response.json();
                    resolve(responseJson);
                } catch (e) {
                    console.error(e);
                    reject(e);
                }
            }
        }
        else {
            try {
                let responseJson = await response.json();
                reject({...responseJson, status: response.status});
            } catch (e) {
                //avoid response data can't serialization to json
                console.error(e);
                reject({status: response.status});
            }
        }
    } catch (e) {
        console.error(e);
        reject(e);
    }
}

function check2XXStatus(status) {
    return status >= 200 && status < 300;
}

function getApiTokenHeader() {
    return {Authorization: apiToken};
}


export default DomainCommon;



// WEBPACK FOOTER //
// ./src/service/common.js